import { jsxs as b, jsx as t } from "react/jsx-runtime";
import { forwardRef as V } from "react";
import { tv as L } from "../tailwind-variants.config.js";
import { ErrorMessage as _ } from "../ErrorMessage/index.js";
import { ButtonLoader as B } from "../Button/ButtonLoader.js";
const C = "_root_1jput_2", I = {
  root: C
}, P = L({
  base: "jm-flex jm-gap-2 jm-px-4 jm-rounded-lg jm-bg-white jm-outline-none jm-ring-0 jm-border jm-border-solid has-[:focus]:jm-border-jutro-new-blue-700 has-[:disabled]:jm-bg-jutro-new-warm-gray-100 jm-w-full jm-box-border",
  variants: {
    color: {
      primary: "jm-text-jutro-new-warm-gray-800 jm-border-jutro-new-warm-gray-500",
      secondary: "jm-text-jutro-gray-dark jm-border-jutro-gray-dark"
    },
    error: {
      true: "has-[:focus]:jm-border-transparent jm-border-transparent jm-outline jm-outline-offset-0 jm-outline-2 jm-outline-jutro-new-rose-600"
    },
    height: {
      sm: "jm-h-11",
      md: "jm-h-[55px]"
    }
  },
  defaultVariants: {
    color: "primary",
    height: "sm"
  }
}), q = V((r, h) => {
  const {
    name: l,
    label: d,
    value: c,
    onChange: f,
    placeholder: w,
    disabled: p,
    loading: a,
    error: i,
    inputMode: y,
    height: x,
    color: v,
    maxLength: m,
    onFocus: s,
    type: j,
    sideElement: g,
    sideElementPosition: N,
    ...k
  } = r, u = j === "number", S = u && "isFloat" in r && r.isFloat, E = typeof i == "string", F = P({
    color: v,
    error: !!i,
    height: x
  }), M = j === "number" ? "numeric" : y, D = (e) => {
    if (u) {
      if (m && e.length >= m)
        return e.slice(0, m);
      if (r.min && Number(e) < Number(r.min))
        return String(r.min);
      if (r.max && Number(e) > Number(r.max))
        return String(r.max);
    }
  };
  return /* @__PURE__ */ b(
    "div",
    {
      className: `jm-font-geologica jm-flex jm-w-full jm-flex-col jm-gap-1 ${I.root}`,
      children: [
        d && /* @__PURE__ */ t(
          "label",
          {
            htmlFor: l,
            className: "jm-font-label jm-block jm-w-full jm-text-jutro-new-warm-gray-800",
            children: d
          }
        ),
        /* @__PURE__ */ t("div", { className: F, children: /* @__PURE__ */ b(
          "div",
          {
            className: `jm-relative jm-flex jm-w-full jm-gap-2 jm-text-inherit ${N === "start" && "jm-flex-row-reverse"}`,
            children: [
              /* @__PURE__ */ t(
                "input",
                {
                  ...k,
                  onFocus: (e) => {
                    s == null || s(e), e.target.addEventListener("wheel", (o) => o.preventDefault());
                  },
                  inputMode: M,
                  ref: h,
                  id: l,
                  name: l,
                  type: j,
                  placeholder: a ? "" : w,
                  value: c,
                  onChange: (e) => {
                    if (!f)
                      return;
                    const o = e.target.value, n = D(o);
                    n && (e.target.value = n), f(e);
                  },
                  disabled: p || a,
                  className: "jm-peer jm-font-paragraph-1 jm-w-full jm-flex-grow jm-border-none jm-p-0 jm-text-inherit placeholder:jm-text-jutro-new-warm-gray-500 focus:jm-border-transparent focus:jm-outline-none focus:jm-ring-0 disabled:jm-bg-jutro-new-warm-gray-100",
                  onKeyDown: (e) => {
                    if (!u)
                      return;
                    const o = ["e", "E", "+", "-"], n = [",", "."];
                    if (!S && [...o, ...n].includes(e.key)) {
                      e.preventDefault();
                      return;
                    }
                    const K = String(c).length === 0 && n.includes(e.key);
                    (o.includes(e.key) || K) && e.preventDefault();
                  },
                  maxLength: m
                }
              ),
              a && /* @__PURE__ */ t("div", { className: "jm-absolute jm-inset-0 jm-grid jm-place-items-center", children: /* @__PURE__ */ t(B, { variant: "dark" }) }),
              g && !a && /* @__PURE__ */ t("div", { className: "jm-font-label jm-flex jm-items-center jm-border-none peer-disabled:jm-text-jutro-new-warm-gray-800", children: g })
            ]
          }
        ) }),
        E && /* @__PURE__ */ t(_, { error: i })
      ]
    }
  );
});
export {
  q as Input
};
//# sourceMappingURL=index.js.map
